"use client";

import { store } from "@/app/store";
import { Provider as ReduxProvider } from "react-redux";
import { CurrencyProvider } from "@/lib/contexts/CurrencyContext";
import { PatchedSessionProvider } from "@/lib/patchedSessionProvider";
import type { Currency } from "@/lib/utils/currency";

const Provider = ({
	children,
	initialCurrency,
}: {
	children: React.ReactNode;
	initialCurrency?: Currency;
}) => {
	return (
		<CurrencyProvider initialCurrency={initialCurrency}>
			<PatchedSessionProvider
				refetchInterval={0}
				refetchOnWindowFocus={false}
				refetchWhenOffline={false}
				basePath="/api/auth"
			>
				<ReduxProvider store={store}>{children}</ReduxProvider>
			</PatchedSessionProvider>
		</CurrencyProvider>
	);
};

export default Provider;
